import React, { useEffect, useState } from "react";
import { Row, Col, Card, CardBody, Form } from "reactstrap";
import Loader from "pages/Separate/Loader";
import secureLocalStorage from "react-secure-storage";
import Select from "react-select";
import DevProjects from "./DevProjects";
import DigitalProject from "./DigitalProject";
import MaintProjects from "./MaintProject";

const ProjectCreation = ({stageData, getFetchStep}) => {
    const [isLoading, setLoading] = useState(false);
    const token = secureLocalStorage.getItem("auth_token");
    const [type, setTypes] = useState([])
    const projectTypes = [
        {
            label: "Fixed or Dedicated Development Project",
            value: 1
        },
        {
            label: "Maintenance Development Project",
            value: 2
        },
        {
            label: "Digital Marketing Project",
            value: 3
        },
    ]
    useEffect(() => {
        setTypes(projectTypes?.find((obj) => obj?.value == stageData?.project_type))
    },[])


    return (
        <React.Fragment>
            {isLoading && <Loader />}
            <div>
                <div className="mb-3" style={{ padding: "0 11px 0 12px" }}>
                    <Row className="bg-white px-2 py-4 shadow mb-3 justify-content-between align-items-center">
                        <div className="col-md-3">
                            <div>
                                <h5 className="font-size-14 mb-3">Project Type</h5>
                                <div style={{ marginLeft: "0px" }}>
                                    <Select
                                        placeholder="Select Project Type"
                                        className="basic-multi-select"
                                        classNamePrefix="select"
                                        options={projectTypes}
                                        value={type}
                                        onChange={(e) => setTypes(e)}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3"><span className="text-danger">* Project Has been Created For this Customer</span></div>
                    </Row>
                    {type?.value == 1 ? (
                        <DevProjects stageData={stageData} getFetchStep={getFetchStep}/>
                    ) : type?.value == 2 ? (
                        <MaintProjects stageData={stageData} getFetchStep={getFetchStep} />
                    ) : type?.value == 3 ? (
                        <DigitalProject stageData={stageData} getFetchStep={getFetchStep} />
                    ) : null}
                </div>
            </div>
        </React.Fragment>
    );
};

export default ProjectCreation;
